
import { Directive, ViewContainerRef, Input, TemplateRef, HostListener, ElementRef, SimpleChanges } from '@angular/core';
import { FormGroup, NgControl } from '@angular/forms';

@Directive({
  selector: '[appFillInBlankOption]'
})
export class FillInBlankOptionDirective {
  constructor(private el: ElementRef, private ngControl: NgControl) {
  }


  @HostListener('input', ['$event'])
  oninput(event) {
    let strValue = this.el.nativeElement.value.trim();
    const caretPosition = this.el.nativeElement.selectionStart;

    if (strValue.startsWith('['))
      strValue = strValue.substr(1);

    if (strValue.endsWith(']'))
      strValue = strValue.substring(0, strValue.length - 1);

    strValue = strValue.replace(/  +/g, ' ');

    if (strValue.length > 1)
      strValue = strValue.trim();

    // if (strValue.length === 0)
    //   strValue = ' ';

    this.ngControl.control.patchValue(`[${strValue}]`);
    this.el.nativeElement.selectionEnd = caretPosition;
  }

}
